import type { Tick } from "./game.js";

/** Decimals players see per arena: TON moves in fractions of a cent, the rest in cents. */
const DECIMALS: Record<string, number> = { BTC: 2, ETH: 2, SOL: 2, TON: 4, XAU: 2 };

export function fmtPrice(arena: string, p: number | null | undefined): string {
  if (p === null || p === undefined || !Number.isFinite(p)) return "--";
  // A sponsored token can trade far under a dollar: enough decimals that its price still moves.
  const d = DECIMALS[arena] ?? (p < 1 ? 5 : p < 100 ? 4 : 2);
  return p.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function lastPrice(ticks: Tick[] | undefined): number | null {
  return ticks?.length ? ticks[ticks.length - 1]!.p : null;
}

/** Change across the ticks we hold (up to the last 3 minutes), as "+0.12%". */
export function changePct(ticks: Tick[] | undefined): { text: string; up: boolean } | null {
  if (!ticks || ticks.length < 2) return null;
  const first = ticks[0]!.p;
  const pct = ((ticks[ticks.length - 1]!.p - first) / first) * 100;
  return { text: `${pct >= 0 ? "+" : ""}${pct.toFixed(2)}%`, up: pct >= 0 };
}

/** Points for an SVG polyline of the given size, highest price at the top. */
export function sparkline(ticks: Tick[] | undefined, w: number, h: number, pad = 2): string {
  if (!ticks || ticks.length < 2) return "";
  const ps = ticks.map((t) => t.p);
  const lo = Math.min(...ps);
  const hi = Math.max(...ps);
  const span = hi - lo || 1;
  return ps
    .map((p, i) => `${((i / (ps.length - 1)) * w).toFixed(1)},${(pad + (1 - (p - lo) / span) * (h - pad * 2)).toFixed(1)}`)
    .join(" ");
}

export function mmss(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
